import Link from 'next/link';
import type { CSSProperties, ReactNode } from 'react';

/**
 * ⑲ⓒ K-5 링크 게이트 — href 가 있으면 `<Link>`, 없으면 «같은 스타일·같은 내용» 의 링크 아닌 요소.
 *
 * 단지백과(`/apt/complex/…`)처럼 대상이 noindex 일 수 있는 링크에 쓴다. href 는
 * `gatedComplexHref()`(lib/apt/complex-indexable.ts)가 정한다 — 여기서 판정하지 않는다.
 * ⛔ 스타일을 바꾸지 않는다 — 받은 className/style 을 그대로 넘긴다(NXDC D 레인 소관).
 */
export default function MaybeLink({
  href, as = 'span', className, style, children,
}: {
  href: string | null | undefined;
  /** href 가 없을 때 그릴 태그. 블록 카드면 'div'. */
  as?: 'span' | 'div';
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}) {
  if (href) return <Link href={href} className={className} style={style}>{children}</Link>;
  const Tag = as;
  return <Tag className={className} style={style}>{children}</Tag>;
}
